import { AddressDetails } from '../api';

export const defaultAddress: AddressDetails = {
  formattedAddress: '79 Madison Ave, New York, NY 10016, USA',
  address1: '79 Madison Avenue',
  streetNumber: '79',
  city: 'Manhattan',
  latitude: 40.7441619,
  longitude: -73.98531249999999,
  state: 'NY',
  zipCode: '10016',
  placeId: 'liquidDefaultAddress',
};
